import { Reveal } from "@/components/motion";

const STATS = [
  { value: "%99,9", label: "Çalışma Süresi" },
  { value: "7/24", label: "Kesintisiz İzleme" },
  { value: "Sınırsız", label: "Cihaz Yönetimi" },
  { value: "5 dk", label: "Kurulum Süresi" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="border-y border-black/5 bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal
            key={s.label}
            delay={i * 0.08}
            className={`px-8 py-12 text-center md:py-16 ${
              i !== 0 ? "border-l border-black/5" : ""
            } ${i >= 2 ? "max-lg:border-t max-lg:border-black/5" : ""} ${
              i === 2 ? "max-lg:border-l-0" : ""
            }`}
          >
            <p
              data-testid={`stat-value-${i}`}
              className="font-display text-4xl font-bold tracking-tight text-[#003366] md:text-5xl"
            >
              {s.value}
            </p>
            <p className="mt-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#525252]">
              {s.label}
            </p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
